import { call, put, takeEvery } from 'redux-saga/effects'
import { getPayment } from 'services/api/payments'

import { fetchError, fetchSuccess } from './actions'
import { FETCH_PAYMENT } from './actionTypes'

const fetch = function* (action) {
  const { id } = action.payload
  const data = yield call(getPayment, id)

  if (!data.ok) return yield put(fetchError(id, data.error))

  yield put(fetchSuccess(id, data.response))
}

export default function* paymentSaga() {
  yield takeEvery(FETCH_PAYMENT, fetch)
}
